import { render, staticRenderFns } from "./tab-active.vue?vue&type=template&id=f1a2bc66"
import script from "./tab-active.vue?vue&type=script&lang=js"
export * from "./tab-active.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports